export const district_data_hospital = {
    "type": "FeatureCollection",
    "features": [
        {
            "type": "Feature",
            "id": "node/4225138790",
            "properties": {
                "addr:postcode": "44800",
                "addr:street": "Dudhpati",
                "amenity": "hospital",
                "name": "Bhaktapur Hospital Emergency Block",
                "id": "node/4225138790"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4220862,
                    27.6720774
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4243043791",
            "properties": {
                "amenity": "hospital",
                "name": "Madhyapur Hospital",
                "id": "node/4243043791"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3879984,
                    27.6725806
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/4356785907",
            "properties": {
                "amenity": "hospital",
                "location": "bhaktapur",
                "name": "Sahara Herchaha Kendra",
                "operator": "private",
                "id": "node/4356785907"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.4037681,
                    27.6744263
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6064309358",
            "properties": {
                "amenity": "hospital",
                "healthcare": "hospital",
                "name": "Nagarik Community Hospital",
                "toilets:wheelchair": "limited",
                "wheelchair": "yes",
                "id": "node/6064309358"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3750363,
                    27.6742186
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6065425312",
            "properties": {
                "amenity": "hospital",
                "healthcare": "hospital",
                "name": "Madhyapur Hospital Thimi",
                "toilets:wheelchair": "no",
                "wheelchair": "yes",
                "id": "node/6065425312"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.3881738,
                    27.6722536
                ]
            }
        },
        {
            "type": "Feature",
            "id": "node/6065482890",
            "properties": {
                "amenity": "hospital",
                "healthcare": "hospital",
                "name": "District community Eye center",
                "toilets:wheelchair": "no",
                "wheelchair": "yes",
                "id": "node/6065482890"
            },
            "geometry": {
                "type": "Point",
                "coordinates": [
                    85.438899,
                    27.6745463
                ]
            }
        }
    ]
}
